import React, { useState, useEffect } from "react";
import { Button, Caret } from "@cmsgov/ds-medicare-gov";
import uniqueId from "lodash.uniqueid";

interface FloatNavGroupProps {
  header: string;
  hideAfterNavigation?: (
    event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>
  ) => void;
}

const FloatNavGroup: React.FunctionComponent<FloatNavGroupProps> = ({
  children,
  header,
  hideAfterNavigation,
}) => {
  const [open, setOpen] = useState(false);
  const [uniqueContainerId, setUniqueContainerId] = useState("");

  useEffect(() => {
    if (children) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const childIds = React.Children.map(children, (child: any) => {
        if (child && child.props) {
          return child.props.href;
        }
        return false;
      });

      if (childIds && childIds.find(id => window.location.href.includes(id))) {
        setOpen(true);
      }
    }
    setUniqueContainerId(uniqueId("float_nav_group_"));
  }, []);

  return (
    <div className="FloatNavGroup">
      <Button
        onClick={(): void => {
          setOpen(!open);
        }}
        data-testid="float-nav-group-button"
        className="FloatNavGroup__button"
        aria-expanded={open}
        aria-controls={uniqueContainerId}
      >
        {header}
        <Caret up={open} className="ds-u-margin-x--2" />
      </Button>
      <ul
        id={uniqueContainerId}
        className={`FloatNavGroup__list${open ? "" : " hidden"}`}
      >
        {React.Children.map(
          children as React.ReactElement[],
          (child: React.ReactElement) => {
            if (React.isValidElement(child)) {
              return React.cloneElement(child as React.ReactElement, {
                hideAfterNavigation,
              });
            }

            return <></>;
          }
        )}
      </ul>
    </div>
  );
};

export default FloatNavGroup;
